import React from 'react';
import { Typography } from 'src/ui/common/atoms/typography';
import {
    StyledGrid,
    StyledCol,
    StyledContent,
    StyledWrapper, StyledMask,
} from 'src/features/common/collectible/components/nft-tabs-empty-state/styles';

export const NftTabsEmptyState:React.FC<{ title: string }> = ({ title, children }) => (
    <StyledWrapper alignItems='center' justifyContent='center'>
        <StyledContent>
            <Typography center variant='title' size='base'>
                {title}
            </Typography>
            <Typography size='sm'>{children}</Typography>
        </StyledContent>
        <StyledMask />
        <StyledGrid xs={4} columnGap={10}>
            <StyledCol>
                <div />
                <div />
                <div />
            </StyledCol>
            <StyledCol>
                <div />
                <div />
                <div />
            </StyledCol>
            <StyledCol>
                <div />
                <div />
                <div />
            </StyledCol>
            <StyledCol>
                <div />
                <div />
                <div />
            </StyledCol>
        </StyledGrid>
    </StyledWrapper>
);
